module.exports = __webpack_public_path__ + "res/12-img_bg_l.a89272fa1441c7c6120ac833afba9db8.png";